module.exports = __webpack_public_path__ + "static/media/Ley_26667.db9f8db1.pdf";